<div class="container-fluid">
  <nb-accordion>
    @for (energyType of energyTypes; track energyType; let i = $index) {
      <nb-accordion-item
        [expanded]="!energyType.collapsed"
        (collapsedChange)="collapsedChange(i, $event)"
        >
        <nb-accordion-item-header>
          <span class="energy-type"
            [style.backgroundColor]="energyType.color || 'transparent'"
            [style.border]="energyType.color && energyType.color !== '#ffffff' ? '2px solid '+ energyType.color : '2px solid #000000'"
            [style.color]="energyType.color && energyType.color === '#ffffff' ? '#000000' : '#ffffff'"
            >
            {{ energyType.name }}
          </span>
          &nbsp;&nbsp;&nbsp;
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <a (click)="seeEmissionFactorList($event, energyType)">{{ "See referentials" | translate }}</a>
          <div class="ag-table">
            @if (!energyType.collapsed) {
              <app-ag-grid-site-providers [energyTypeId]="energyType.id"></app-ag-grid-site-providers>
            }
          </div>
        </nb-accordion-item-body>
      </nb-accordion-item>
    }
  </nb-accordion>
</div>
